import React from 'react'
import { Form, Col } from 'react-bootstrap'

// componente input textarea sem validacao
const ControlAreaWithValidation = ({
    Col, 
    label, 
    name, 
    placeholder,
    value, 
    error,
    handleChange,
    typeColumn="md", 
    valueColumn,
    readOnly=false
  }) => (
    typeColumn === "md"
    ?
      <Col md>
        <Form.Group as={Col} controlId={name}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                as="textarea"
                placeholder={placeholder}
                style={{ height: '100px' }}
                name={name}
                value={value}
                onChange={handleChange}
                isInvalid={!!error}
                readOnly={readOnly}
            />
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </Form.Group>
      </Col>
    :
      <Col xs={valueColumn}>
        <Form.Group as={Col} controlId={name}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                as="textarea"
                placeholder={placeholder}
                style={{ height: '100px' }}
                name={name}
                value={value}
                onChange={handleChange}
                isInvalid={!!error}
                readOnly={readOnly}
            />
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </Form.Group>
      </Col>
  )

export default ControlAreaWithValidation;